module.exports = __webpack_public_path__ + "img/pagination-energySavings.9687cc78.svg";